import { render, staticRenderFns } from "./update.vue?vue&type=template&id=63b3dd84&scoped=true&"
import script from "./update.vue?vue&type=script&lang=ts&"
export * from "./update.vue?vue&type=script&lang=ts&"
import style0 from "./update.vue?vue&type=style&index=0&id=63b3dd84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b3dd84",
  null
  
)

export default component.exports